import { Loader2, Clock } from 'lucide-react';

type RefreshIndicatorProps = {
  lastRefreshed: string | null;
  isRefreshing: boolean;
};

const formatTimestamp = (iso: string): string => {
  const date = new Date(iso);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const RefreshIndicator = ({
  lastRefreshed,
  isRefreshing,
}: RefreshIndicatorProps) => {
  if (isRefreshing) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        <span>Refreshing data...</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-sm text-gray-500">
      <Clock className="h-3.5 w-3.5" />
      <span>
        Last updated:{' '}
        {lastRefreshed ? formatTimestamp(lastRefreshed) : 'Never'}
      </span>
    </div>
  );
};
